import styled from "styled-components";

export const Card1Style = styled.div`  .card-container {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 1vh 1.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    min-width: 35vh;
    height: 15vh;
    margin-bottom: 5vh;
    overflow-wrap: anywhere;
    font-family: medium-pro, sans-serif;
    margin-right: 4vh;
    margin-left: 4vh;
    justify-content: space-between;
    cursor: pointer;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }

  .card-container.selected {
    background-color: #f28809;
    border: 2px solid #f28809;
    box-shadow: 0 0 20px rgba(242, 136, 9, 0.5);
    color: white;
  }

  .card-container.selected .heading {
    color: white;
  }

  .card-container.selected .total,
  .card-container.selected .total-sm {
    color: white;
  }

  .config-heading {
    font-size: 1.4rem;
  }

  .arrow-style {
    font-size: 25px;
    :hover {
      color: #f28809;
    }
  }
  .heading {
    font-size: 1.5vh;
    align-self: center;
    color: #5e5d5c;
  }
  .total {
    font-size: 2vh;
    font-weight: 400;
    align-self: center;
  }

  .total-sm {
    font-size: 1.5vh;
    font-weight: 400;
    align-self: center;
  }

  /* For large devices */
  @media screen and (max-width: 1024px) {
    .card-container {
      height: 12vh;
    }
    .heading {
    }
    .total {
    }
    .total-sm {
    }
  }

  /* For medium devices */
  @media screen and (max-width: 576px) {
    .card-container {
      margin-right: 0;
    }
  }
`;
